<a tabindex="1" (click)="onLinkClick()" class="margin-left-5 font-monospace font-weight-bold" [matTooltip]="tooltipText">
  <ng-content></ng-content>
</a>
